module.exports = __webpack_public_path__ + "img/52800.47372792.jpg";